import { getAppStorageItem } from './storageProxy';

const hasVerificationStatus = (value) => value !== null && value !== undefined && value !== 'null';

export const hasDashboardPageAccess = (userData = {}) => {
  const userType = Number(userData?.user_type ?? getAppStorageItem('user_type'));
  const verificationStatus = userData?.verification_status ?? getAppStorageItem('verification_status');

  if (userType === 6) {
    return true;
  }

  if ((userType === 2 || userType === 8) && !hasVerificationStatus(verificationStatus)) {
    return true;
  }

  return false;
};

export default hasDashboardPageAccess;
